// 无需布局的路由

const out = [
  {
    path: '/preview',
    name: 'preview',
    meta: {
      title: '课程预览',
      type: 'menu',
      hidden: true,
      auth: true
    },
    component: () => import('@/views/Preview')
  }
]

export default out
